module.exports = "/_next/static/images/WantToRetainCustomers-sm-c2b31c298b2677315c496a9fc79c55b9.png";